/* tslint:disable:component-selector */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NinjaData } from 'src/app/models/ninja-data.model';

@Component({
  selector: 'countries-list',
  templateUrl: './countries-list.component.html',
  styleUrls: ['./countries-list.component.scss']
})
export class CountriesListComponent implements OnInit {

  rowHovered = false;

  @Input() dataSource: NinjaData[];
  countries: MatTableDataSource<NinjaData>;
  displayedColumns = [
    'index', 'flag', 'country', 'cases', 'deaths', 'mortalityRate', 'deathsPerOneMillion',
    'testsPerOneMillion', 'casesPerMillion', 'details-icon'
  ];

  @ViewChild(MatSort, { static: true }) private sort: MatSort;


  ngOnInit(): void {
    this.countries = new MatTableDataSource(this.dataSource);
    this.countries.filterPredicate = this.filterCountries;
    this.countries.sort = this.sort;
    this.countries.sortingDataAccessor = this.sortingCountries;
  }

  searchCountries(searchQuery: string): void {
    this.countries.filter = searchQuery.toLowerCase().trim();
  }

  private filterCountries = (country: NinjaData, filter: string): boolean => {
    return country.country.toLowerCase().startsWith(filter);
  };

  private sortingCountries = (country: NinjaData, headerId: string): string | number => {
    if (headerId === 'mortalityRate') {
      return country.cases / country.deaths;
    }
    return country[headerId];
  };
}
